module.exports = __webpack_public_path__ + "static/media/dark.f4be88f0.svg";